<div class="container-fluid" style="padding: 0px 5px;">
    <div style=" display: inline;block-size: 10%;">
        <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding: 10px;">
            <div class="col-md-6 col-sm-6" style="display: inline-block; padding: 0px; ">
                <h2 class="header lblHeader newHeader" style="font-size: 25px; margin-top: 5px;">
                    Task Records
                </h2>
            </div>
            <!-- Search -->
            <div class="col-md-6 col-sm-6" style="display: inline-block; padding: 0px;text-align: right;">
                <span class="search" *ngIf="dataSource.data.length > 0"
                    style="position: relative; display: inline-block; width: 29%; vertical-align: middle;">
                    <span class="fa fa-search"
                        style="padding-left: 13px; font-size: 13px; position: absolute; top: 50%; transform: translateY(-50%); color: #999;">
                    </span>
                    <input class="form-control formCtlFltr brdrRadius3" placeholder="Search" matInput
                        (keyup)="applySearch($event)"
                        style="text-align: left; background-color: white ! important; display: inline-block; padding-left: 35px !important;  font-size: 13px; box-shadow: none; width: 100%; height: 31px !important;"
                        type="text">
                </span>

                <!-- Export to Excel  -->
                <span *ngIf="dataSource.data.length > 0" (click)="exportToExcelTasks()" class="orangeButton"
                    style="margin-left: 10px; cursor: pointer;" title="Export to Excel">
                    <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
                </span>

                <!-- Back Button (Return To Task) -->
                <div style="display: inline-block; padding: 0px; vertical-align: middle;"
                    title="Back to Tasks">
                    <span class="darkBlueButton"
                        style="font-size: 13px; display: inline-block; padding: 5px 12px 6px; margin-left: 10px;"
                        (click)="returnToTasks()">
                        <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Tasks
                    </span>
                </div>
            </div>
        </div>

        <!-- Filters -->
        <div class="col-md-12" style="padding: 5px 0px; margin-top: -10px">
            <!-- Status Filter & Assigner/Assignee -->
            <div class="col-md-12" style="display: inline-block;">

                <!-- Status -->
                <div class="" style="display: inline-block; margin-top: 17px;">
                    <select class="form-control bgwhite formCtlFltr"
                        style="box-shadow: none;width: 125px;cursor: pointer;" [(ngModel)]="selectedStatus"
                        (change)="onStatusChange()">
                        <option value="Pending">Pending</option>
                        <option value="Completed">Completed</option>
                    </select>
                </div>

                <!-- Assigner -->
                <div class="" style="display: inline-block; margin-top: 17px; margin-left:15px;">
                    <select class="form-control bgwhite formCtlFltr"
                        style="box-shadow: none;width: 150px;cursor: pointer;" [(ngModel)]="selectedAssigner"
                        (change)="onAssignerChange()">
                        <option value="0">All Assigners</option>
                        <option *ngFor="let u of userList" [value]="u.UserID">{{u.Name}}</option>
                    </select>
                </div>

                <!-- Assignee -->
                <div class="" style="display: inline-block; margin-top: 17px; margin-left:15px;">
                    <select class="form-control bgwhite formCtlFltr"
                        style="box-shadow: none;width: 150px;cursor: pointer;" [(ngModel)]="selectedAssignee"
                        (change)="onAssigneeChange()">
                        <option value="0">All Assignees</option>
                        <option *ngFor="let u of userList" [value]="u.UserID">{{u.Name}}</option>
                    </select>
                </div>

                <!-- Month & Date (Only if Completed) -->
                <div *ngIf="selectedStatus === 'Completed'" style="display:inline-block; padding: 0px;margin-left: 15px;">
                    <div style="display: inline-block;">
                        <label
                            style="margin-left: 0px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;">Month
                            : </label>
                    </div>
                    <div style="display: inline-block;margin-left: 5px;">
                        <select class="form-control bgwhite formCtlFltr "
                            style="box-shadow: none;width: 100px;cursor: pointer;" [(ngModel)]="selectedMonthID"
                            (change)="onMonthChange()">
                            <option *ngFor="let m of months" [value]="m.id">{{m.display}}</option>
                        </select>
                    </div>
                </div>

                <!-- Select Date -->
                <div *ngIf="selectedStatus === 'Completed'" style="display: inline-block; margin-left: 15px; vertical-align: middle;">
                    <div class="checkbox font13" style="display: flex; align-items: center; margin: 0;">
                        <label
                            style="margin-bottom: 0px !important; cursor: pointer; display: flex; align-items: center; font-weight: normal;">
                            <input type="checkbox" class="chkbox-darkblue" [(ngModel)]="showDate"
                                (change)="toggleDateFilter()"
                                style="margin-right: 5px;font-size: 13px; margin-top: 0;">Select Date
                        </label>
                        <div *ngIf="showDate == true" style="margin-left: 10px; display: flex; align-items: center;">
                            <div style="outline: none !important; display: flex; align-items: center;">
                                <input matInput readonly (focus)="picker.open()" [matDatepicker]="picker" [min]="minDT"
                                    [max]="maxDT" class="form-control" [(ngModel)]="selectedDate"
                                    (ngModelChange)="applyFilters()"
                                    style="width: 100px; outline: none !important; cursor: pointer; background: #FFF; height: 30px !important; margin-right: 5px;">
                                <mat-datepicker-toggle matSuffix [for]="picker"
                                    style="outline: none !important;"></mat-datepicker-toggle>
                                <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Table -->
        <div class="wrapper"
            style=" padding:0px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding: 5px 5px; margin-left: 10px; margin-right:5px; border-radius: 3px;">
            <table mat-table [dataSource]="dataSource" matSort
                style="border-radius: 3px; padding-left: 16px !important; padding: 0px;"
                *ngIf="dataSource.data.length > 0">

                <ng-container matColumnDef="Task">
                    <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef mat-sort-header
                        style="padding-top: 10px; padding-bottom: 5px; padding-left: 10px;">
                        <label style="font-size: 13px;">Task</label>
                    </th>
                    <td mat-cell *matCellDef="let element"
                        style="text-align: left; padding-right: 52px ! important;vertical-align: middle; padding-left: 10px ! important; text-overflow: ellipsis; white-space: initial;">
                        {{element.Task}} <span style="color: #999;" title="#{{element.TaskID}}">(#{{element.TaskID}})</span> </td>
                </ng-container>

                <ng-container matColumnDef="Detail">
                    <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef mat-sort-header
                        style="padding-top: 10px; padding-bottom: 5px; padding-left: 10px;">
                        <label style="font-size: 13px;">Description</label>
                    </th>
                    <td mat-cell *matCellDef="let element"
                        style="text-align: left; vertical-align: middle;text-overflow: ellipsis; white-space: initial; padding-left: 10px ! important;">
                        {{element.Detail ? element.Detail : '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="FromUserName">
                    <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef mat-sort-header
                        style="padding-top: 10px; padding-bottom: 5px;">
                        <label style="font-size: 13px;">Assigner</label>
                    </th>
                    <td mat-cell *matCellDef="let element"
                        style="text-align: left; padding-right: 52px !important;vertical-align: middle; padding-left: 0px ! important;">
                        {{element.FromUserName}} </td>
                </ng-container>

                <ng-container matColumnDef="ToUserName">
                    <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef mat-sort-header
                        style="padding-top: 10px; padding-bottom: 5px;">
                        <label style="font-size: 13px;">Assignee</label>
                    </th>
                    <td mat-cell *matCellDef="let element"
                        style="text-align: left; padding-right: 52px !important;vertical-align: middle; padding-left: 0px ! important;">
                        {{element.ToUserName}} </td>
                </ng-container>

                <ng-container matColumnDef="CreatedDT">
                    <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef mat-sort-header
                        style="padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                        <label style="font-size: 13px; width: 10%;">Assigned on</label>
                    </th>
                    <td mat-cell *matCellDef="let element"
                        style="text-align: left; padding-right: 52px !important;vertical-align: middle; padding-left: 9px ! important;">
                        <span [class]="element.CreatedColor">{{element.CreatedDT | todayTommorow}}</span> </td>
                </ng-container>

                <ng-container matColumnDef="ExpCompletionDT">
                    <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef mat-sort-header
                        style="padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                        <label style="font-size: 13px; width: 10%;">Due on</label>
                    </th>
                    <td mat-cell *matCellDef="let element"
                        style="text-align: left; padding-right: 52px !important;vertical-align: middle;">
                        <span [class]="element.Color">{{element.ExpCompletionDT | todayTommorow}}</span> </td>
                </ng-container>

                <ng-container matColumnDef="DoneDT" style="display:inline-block ;">
                    <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef mat-sort-header
                        style="padding-top: 10px; padding-bottom: 5px; padding-left: 8px;">
                        <label style="font-size: 13px; width: 10%;">Completed on</label>
                    </th>
                    <td mat-cell *matCellDef="let element"
                        style="text-align: left; padding-right: 52px !important;vertical-align: middle; padding-right: 0px ! important;">
                         <span [class]="element.DoneColor">{{element.DoneDT ? (element.DoneDT | todayTommorow) : '-'}}</span> </td>
                </ng-container>

                <ng-container matColumnDef="Priority">
                    <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef mat-sort-header
                        style="padding-top: 10px; padding-bottom: 5px; padding-left: 7px;">
                        <label style="font-size: 13px;">Priority</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: left; vertical-align: middle;">
                        {{element.Priority}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <mat-paginator style="border-radius: 0px 0px 3px 3px;" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons
                *ngIf="dataSource.data.length > 0"></mat-paginator>

            <div *ngIf="dataSource.data.length == 0" style="padding: 0px 0px;">
                <div class="nrf brdrRadius3">No records found.</div>
            </div>
        </div>
    </div>
</div>